// extracted by mini-css-extract-plugin
export default {"container":"Filtering_container__2r0TU","fromList":"Filtering_fromList__op6DD","wrapper":"Filtering_wrapper__SE72J"};